import React from 'react';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Benefits } from '../components/Benefits';
import { Pricing } from '../components/Pricing';
import { motion, useScroll, useSpring } from 'framer-motion';
export function LandingPage() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  return <div className="bg-sovereign-navy selection:bg-sovereign-gold selection:text-sovereign-navy" data-id="element-231">
      {/* Progress Bar */}
      <motion.div className="fixed top-0 left-0 right-0 h-1 bg-sovereign-gold origin-left z-50" style={{
      scaleX
    }} data-id="element-232" />

      <div className="-mt-20" data-id="element-233">
        <Hero data-id="element-234" />
      </div>

      <div id="features" data-id="element-235">
        <Features data-id="element-236" />
      </div>

      <Benefits data-id="element-237" />

      <div id="pricing" data-id="element-238">
        <Pricing data-id="element-239" />
      </div>
    </div>;
}